import axios from 'axios';
import AgreementDraftEntity from './agreement-draft-entity';

class AgreementDraftService {

  hydrate (data) {
    if (data) {
      return new AgreementDraftEntity(
        data.id,
        data.headline,
        data.language_id,
        data.text,
        data.type_id
      );
    }

    return {};
  }

  extractParams (params) {
    return {
      data: {
        attributes: {
          user_id: params.userId,
          company_id: params.customerId,
          specification: params.specification,
          firstWorkDate: params.firstWorkDate,
          lastWorkDate: params.lastWorkDate,
          language_id: params.languageId
        }
      }
    };
  }

  post (params) {
    let data = this.extractParams(params);

    return axios.post('backend://agreement-drafts', data)
      .then((response) => {
        let attr = response.data.data.attributes;
        return [this.hydrate(attr[0]), this.hydrate(attr[1])];
      });
  }

  generalTerms (languageId) {
    return axios.post('backend://general-terms', {
      data: {
        attributes: {
          language_id: languageId
        }
      }
    })
      .then((response) => {
        let attr = response.data.data.attributes;
        return this.hydrate(attr[0]);
      });
  }

}

export default new AgreementDraftService();



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/agreement-drafts/agreement-draft-service.js
 **/